import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { PagesHelper } from "../common/PagesHelper";
import { CLinkOwnerOption, CLinkRecord } from "../utils/types";
import parse from 'html-react-parser';
import TagsList from "./clinks/tags/TagsList";
import { formatSearchInRowToBold } from "../utils/misc";
import { InputGroup } from "react-bootstrap";
import AutocompleteIncludeExclude from "./library/AutocompleteIncludeExclude";

function CLinkOwnersAutocomplete(props: any) {
  const labelKeyFunction = function (cLinkOwner: CLinkOwnerOption) {
    return PagesHelper.fromCLinkOwnerOptionToString(cLinkOwner);
  }

  const trafficSourceResponseDto = props.trafficSourceResponseDto;
  const renderMenuItemChildren = (option: CLinkOwnerOption, props : any, index : any) => {
    const cLinkRecord:CLinkRecord = (option.record as CLinkRecord);
    const ownerOrTagRecord:string = (option.record as string);
    const publisher = trafficSourceResponseDto && trafficSourceResponseDto.publishersArray ? trafficSourceResponseDto.publishersArray.find((p: any) => p.id === cLinkRecord.apptapPublisherId) : null;
    const apptapPublisherName = publisher?.record?.apptapPublisherName ? publisher?.record?.apptapPublisherName : "";

    const search = props.text;
    let menuItem = null;

    if (cLinkRecord.cLinkId) {
      const wordsToSearch = search.split(" ");
      let firstRow:string = cLinkRecord.cLinkId;
      let secondRow:string = `${apptapPublisherName} (${cLinkRecord.apptapPublisherId}:${cLinkRecord.apptapSiteId}`;
      let thirdRow:string = cLinkRecord.productId;
      wordsToSearch.forEach((word:string) => {
        if (word) {
          firstRow = formatSearchInRowToBold(firstRow, word);
          secondRow = formatSearchInRowToBold(secondRow, word);
          thirdRow = formatSearchInRowToBold(thirdRow, word);
        }
      });

      menuItem =  (
        <div style={{ paddingLeft : "25px"}}>
          <div>{ parse(firstRow) }</div>
          <div>{ parse(secondRow) }</div>
          <div>{ parse(thirdRow) } <TagsList tagsList={cLinkRecord.tags} search={search} /></div>
        </div>
      )
    } else if (ownerOrTagRecord.includes("#")) {
      menuItem = (
        <div style={{fontWeight: "bold"}}>
          <TagsList tagsList={[option.text]} search={search} containerStyles={{ margin: "0 4px 0 0" }} tagStyles={{ margin: "0 4px" }} />
        </div>
      )
    } else {
      menuItem = (
        <div style={{fontWeight: "bold"}}>
          <strong>{ownerOrTagRecord}</strong>
        </div>
      )
    }
    return menuItem;
  }

  return (
    <InputGroup>
      {
        props.useIncludeExclude ? 
          <AutocompleteIncludeExclude
            defaultIncludeExclude={props.defaultIncludeExclude}
            includeExcludeOnChange={props.includeExcludeOnChange}
          />
        :
          null
      }
      <AsyncTypeahead size="sm"
        id="cLinkOwnersAutocomplete"
        labelKey={labelKeyFunction}
        renderMenuItemChildren={renderMenuItemChildren}
        onSearch={props.searchCLinkOwners}
        isLoading={props.clinkOwnersIsLoading}
        onInputChange={props.onInputChange}
        options={props.options}
        selected={props.selected}
        onChange={props.onChange}
        disabled={props.disabled}
        ref={props.reactRef}
        useCache={false}
        placeholder={props.placeholder}
        minLength={0}
        filterBy={() => true}
        clearButton
        multiple
      />
    </InputGroup>
  );
}

export default CLinkOwnersAutocomplete;